import { Modal } from "antd";
import { TableWarehouses } from "../../../../modules/sauces/ui/sauceById/TableWarehouses";

export const ModalSauceWarehouses = ({
  openModal,
  setOpenModal,
}: {
  openModal: boolean;
  setOpenModal: (val: boolean) => void;
}) => {

  return (
    <Modal
      footer={null}
      style={{}}
      title={`Asignar una salsa a la bodega`}
      open={openModal}
      width={"90%"}
      onCancel={() => setOpenModal(false)}
    >
      <TableWarehouses />
    </Modal>
  );
};
